module.exports = __webpack_public_path__ + "img/issuing-sample-badge.f4605086.svg";